<template>
  <div>
    <div class="w-home_banner">
      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide w-swiper_item1">
            <div class="w-item_title">{{ this.$t('home.xyLocator') }}</div>
            <div class="w-button_text w-item_text">{{ this.$t('home.locatorText') }}</div>
            <!-- <div class="w-item1_title">查看更多</div> -->
            <div class="w-item_more w-transform_timing" @click="handSolution(1)">
              <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
              <i class="iconfont icon-common_icon_more w-button_text"></i>
            </div>
          </div>
          <div class="swiper-slide w-swiper_item2">
            <div class="w-item_title">{{ this.$t('home.solutionsItemTitle1') }}</div>
            <div class="w-button_text w-item_text">{{ this.$t('dSCircularPackaging.scenariosText1') }}</div>
            <!-- <div class="w-item1_title">查看更多</div> -->
            <div class="w-item_more w-transform_timing"  @click="handSolution(2)">
              <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
              <i class="iconfont icon-common_icon_more w-button_text"></i>
            </div>
          </div>
          <div class="swiper-slide w-swiper_item3">
            <div class="w-item_title">{{ this.$t('home.solutionsItemTitle2') }}</div>
            <div class="w-button_text w-item_text">{{ this.$t('dSCircularPackaging.vehicleTex3') }}</div>
            <!-- <div class="w-item1_title">查看更多</div> -->
            <div class="w-item_more w-transform_timing"  @click="handSolution(3)">
              <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
              <i class="iconfont icon-common_icon_more w-button_text"></i>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="w-home_aboutUs">
      <XYTitle xText="ABOUT US"></XYTitle>
      <div class="w-about_large">
        <div class="w-large_left">
          <Animation defaultClass="w-transform_right" animationClass="w-transform_show">
            <span class="w-moduleBanner_text w_xuyu">{{ this.$t('home.xyTechnology') }}</span>
            <!-- <span class="w-subsidiary_text technology">XUYU TECHNOLOGY</span> -->
          </Animation>
          <Animation defaultClass="w-transform_right" animationClass="w-transform_show">
            <div class="w_aboutUsMore w-transform_timing" @click="handAboutUs">
              <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
              <i class="iconfont icon-common_icon_more w-button_text"></i>
            </div>
          </Animation>
        </div>
        <div class="w-large_right">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <span class="w-smallTitle_text">“{{ this.$t('home.worryFreePositioning') }}。”</span>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <p class="w-paragraph1_text">{{ this.$t('home.aboutLargeText') }}</p>
          </Animation>
          <!-- <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-number_group">
              <div>
                <div>
                  <NumberLoader :targetNumber="20" :duration="500" :numClass="'w-homeNumber_text w_number'">
                    <span class="w_suspension w_sign">+</span>
                  </NumberLoader>
                </div>
                <span class="w-nonParagraph_text w_text1">{{ this.$t('home.productSeries') }}</span>
              </div>
              <div>
                <div>
                  <NumberLoader :targetNumber="20" :duration="500" :numClass="'w-homeNumber_text w_number'">
                    <span class="w_suspension w_year">{{ this.$t('home.year') }}s</span>
                  </NumberLoader>
                </div>
                <span class="w-nonParagraph_text w_text1">{{ this.$t('home.technicalExperience') }}</span>
              </div>
              <div>
                <div>
                  <NumberLoader :targetNumber="2" :duration="100" :numClass="'w-homeNumber_text w_number'"></NumberLoader>
                </div>
                <span class="w-nonParagraph_text w_text1">{{ this.$t('home.researchAndDevelopmentCenter') }}</span>
              </div>
              <div>
                <div>
                  <NumberLoader :targetNumber="3000" :duration="500" :numClass="'w-homeNumber_text w_number'">
                    <span class="w_suspension w_sign">+</span>
                  </NumberLoader>
                </div>
                <span class="w-nonParagraph_text w_text1">{{ this.$t('home.cooperativeClient') }}</span>
              </div>
            </div>
          </Animation> -->
        </div>
      </div>
    </div>
    <div class="w-home_solutions">
      <XYTitle xText="SOLUTIONS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-moduleBanner_text w-solution_banner">{{ this.$t('home.solutionsTitle') }}</div>
      </Animation>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-solution_box">
          <div class="w-col_box" style="background-image: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_solution1.jpg')" @click="handSolution(2)">
            <div class="w-box_text">
              <div class="w-moduleBanner_text">{{ this.$t('home.solutionsItemTitle1') }}</div>
              <div class="w-paragraph_text">{{ this.$t('home.solutionsItemText1') }}</div>
              <div class="w-solution_more w-transform_timing">
                <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                <i class="iconfont icon-common_icon_more w-button_text"></i>
              </div>
            </div>
          </div>
          <div class="w-col_box" style="background-image: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_solution2.jpg')" @click="handSolution(3)">
            <div class="w-box_text">
              <div class="w-moduleBanner_text">{{ this.$t('home.solutionsItemTitle2') }}</div>
              <div class="w-paragraph_text">{{ this.$t('home.solutionsItemText2') }}</div>
              <div class="w-solution_more w-transform_timing">
                <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                <i class="iconfont icon-common_icon_more w-button_text"></i>
              </div>
            </div>
          </div>
        </div>
      </Animation>
    </div>
    <div class="w-home_product">
      <XYTitle xText="MAIN PRODUCTS" class="w_xyTitle"></XYTitle>
      <div class="w-product_large">
        <div class="w-product_title">
          <div class="w-moduleBanner_text">{{ this.$t('home.productsTitle') }}</div>
          <div class="w-paragraph_text w-product_text1">{{ this.$t('home.productText') }}</div>
        </div>
        <img class="w-product_bg" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/home/home_bg_xuyu.png" alt="#" />
        <div class="w-product_list1" style="height: 674px">
          <Animation defaultClass="w-transform_left" animationClass="w-transform_show" v-show="isOne">
            <div class="w-list_box1 w-product_hover">
              <div class="hover_box" @click="handProduct('D98')">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product1.png" alt="" />
                <div>
                  <div class="w-hover_move">
                    <span class="w-moduleBanner_text w_xuyu">D98</span>
                    <div class="w_aboutUsMore w-transform_timing">
                      <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                      <i class="iconfont icon-common_icon_more w-button_text"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hover_box" @click="handProduct('D96')">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product2.png" alt="" />
                <div>
                  <div class="w-hover_move">
                    <span class="w-moduleBanner_text w_xuyu">D96</span>
                    <div class="w_aboutUsMore w-transform_timing">
                      <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                      <i class="iconfont icon-common_icon_more w-button_text"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hover_box" @click="handProduct('D92')">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product3.png" alt="" />
                <div>
                  <div class="w-hover_move">
                    <span class="w-moduleBanner_text w_xuyu">D92</span>
                    <div class="w_aboutUsMore w-transform_timing">
                      <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                      <i class="iconfont icon-common_icon_more w-button_text"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Animation>
          <Animation defaultClass="w-transform_left" animationClass="w-transform_show" v-show="!isOne">
            <div class="w-list_box2 w-product_hover">
              <div class="hover_box" @click="handProduct('D82')">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product4.png" alt="" />
                <div>
                  <div class="w-hover_move">
                    <span class="w-moduleBanner_text w_xuyu">D82</span>
                    <div class="w_aboutUsMore w-transform_timing">
                      <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                      <i class="iconfont icon-common_icon_more w-button_text"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hover_box" @click="handProduct('D60')">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product5.png" alt="" />
                <div>
                  <div class="w-hover_move">
                    <span class="w-moduleBanner_text w_xuyu">D60</span>
                    <div class="w_aboutUsMore w-transform_timing">
                      <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                      <i class="iconfont icon-common_icon_more w-button_text"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hover_box" @click="handProduct('蓝牙信标')">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product6.png" alt="" />
                <div>
                  <div class="w-hover_move">
                    <span class="w-moduleBanner_text w_xuyu">{{ this.$t('home.productBlueTooth') }}</span>
                    <div class="w_aboutUsMore w-transform_timing">
                      <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                      <i class="iconfont icon-common_icon_more w-button_text"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Animation>
          <div class="w-list_btn">
            <i class="iconfont icon-home_icon_left" @click="isOne = !isOne"></i>
            <i class="iconfont icon-home_icon_right" @click="isOne = !isOne"></i>
          </div>
        </div>
        <div class="w-product_list2">
          <div class="hover_box" @click="handProduct('D98')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product1.png" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D98</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="hover_box" @click="handProduct('D96')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product2.png" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D96</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="hover_box" @click="handProduct('D92')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product3.png" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D92</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="hover_box" @click="handProduct('D82')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product4.png" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D82</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="hover_box" @click="handProduct('D60')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product5.png" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D60</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="hover_box" @click="handProduct('蓝牙信标')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product6.png" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">{{ this.$t('home.productBlueTooth') }}</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="w-home_partner">
      <XYTitle xText="PARTNERS"></XYTitle>
      <Animation defaultClass="w-transform_top w-partner_box" animationClass="w-transform_show">
        <div class="w-moduleBanner_text">{{ this.$t('home.partnersTitle') }}</div>
      </Animation>
      <div class="wpartner_list">
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner1.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner2.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner3.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner4.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner5.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner6.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner7.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner8.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner9.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner10.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner11.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner12.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner13.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner14.png" alt="" />
        </Animation>
      </div>
    </div> -->
    <Footer></Footer>
  </div>
</template>
<script>
import XYTitle from '@/components/XYTitle.vue'
import NumberLoader from '@/components/NumberLoader.vue'
import Animation from '@/components/Animation.vue'
import Footer from '@/components/Footer.vue'
export default {
  props: {},
  data () {
    return {
      isVisible: false,
      isOne: true
    }
  },
  mounted () {
    var swiper = new Swiper(".mySwiper", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  },
  methods: {
    handProduct (data) {
      //点击产品
      this.$emit('openProdect', { activeId: 2, menuName: 'ProductDetail', prodectId: data })
    },
    handSolution (data) {
      //点击解决方案
      if(data==1){
        this.$emit('handMenu',2,'Product')
      }else if(data==2){
        this.$emit('handMenu',3.1, 'Packaging')
      }else if(data==3){
        this.$emit('handMenu',3.2, 'Vehicle')
      }
    },
    handAboutUs(){
      this.$emit('handMenu',4, 'About')
    }
  },
  components: { XYTitle, NumberLoader, Animation, Footer }
}
</script>

<style scoped lang="scss">

</style>
